import React from 'react';
import '../styles/thinking.css';

const ThinkingDisplay = ({ isThinking, message, textDelta }) => {
  return (
    <div className={`thinking-display ${isThinking ? 'active' : ''}`}>
      <div className="thinking-header">
        <div className="thinking-icon">
          <div className="thinking-dot"></div>
          <div className="thinking-dot"></div>
          <div className="thinking-dot"></div>
        </div>
        <span className="thinking-label">AI Reasoning</span>
      </div>

      {isThinking && (
        <div className="thinking-content">
          <p className="thinking-message">{message}</p>
          {textDelta && (
            <div className="thinking-progress">
              <div className="progress-text">{textDelta}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ThinkingDisplay;
